'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableHead = function (_Component) {
  _inherits(TableHead, _Component);

  function TableHead() {
    _classCallCheck(this, TableHead);

    return _possibleConstructorReturn(this, (TableHead.__proto__ || Object.getPrototypeOf(TableHead)).apply(this, arguments));
  }

  _createClass(TableHead, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          style = _props.style,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['style', 'children']),
          _context = this.context,
          containerWidth = _context.containerWidth,
          maxWidth = _context.maxWidth,
          gutterClassName = _context.gutterClassName;

      var maxWidthCellBorders = {
        width: maxWidth !== null ? Math.max(0, containerWidth - maxWidth) / 2 : 0
      };

      return _react2.default.createElement(
        'thead',
        _extends({ style: _extends({ borderBottom: 'lightgray 1px solid' }, style) }, rest),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement('th', { style: maxWidthCellBorders, className: gutterClassName }),
          children,
          _react2.default.createElement('th', { style: maxWidthCellBorders, className: gutterClassName })
        )
      );
    }
  }]);

  return TableHead;
}(_react.Component);

TableHead.contextTypes = {
  containerWidth: _react.PropTypes.number,
  maxWidth: _react.PropTypes.number,
  gutterClassName: _react.PropTypes.string
};
exports.default = TableHead;


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/table/TableHead.js
// module id = 243
// module chunks = 0